import { render } from "./AddSeatRow.vue?vue&type=template&id=aa6ada82&scoped=true"
import script from "./AddSeatRow.vue?vue&type=script&lang=js"
export * from "./AddSeatRow.vue?vue&type=script&lang=js"

import "./AddSeatRow.vue?vue&type=style&index=0&id=aa6ada82&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa6ada82"]])

export default __exports__